import { Action, State, StateContext, Store } from "@ngxs/store";
import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { LocalizationService } from "src/app/services/localization/localization.service";
import { AlertService } from "src/app/shared/store/alert/alert.service";
import { Language } from "../../models/language.model";
import { LanguageTypeActions } from "./language-type.actions";
import { LanguageService } from "../../services/language.service";
import { MappingUtilsService } from "src/app/services/utils/mapping-utils.service";
import { tap } from "rxjs";

export class LanguageStateModel {
    public languages: Language[];
    public error: string;
  }

  const defaults = {
    languages: [],
    error: '',
  };

  @State<LanguageStateModel>({
    name: 'language',
    defaults,
  })
  @Injectable()
  export class LanguageTypeState {
    constructor(
      private alertService: AlertService,
      private localizationService: LocalizationService,
      public store: Store,
      private languageService: LanguageService
    ) {}

    @Action(LanguageTypeActions.GetLanguages) getLanguages(
      ctx: StateContext<LanguageStateModel>,
      {}: LanguageTypeActions.GetLanguages
    ) {
      return this.languageService
        .getLanguages()
        .subscribe({
          next: (response) =>
            ctx.dispatch(new LanguageTypeActions.GetLanguagesSuccess(response)),
          error: (error) =>
            ctx.dispatch(new LanguageTypeActions.GetLanguagesFail(error)),
        });
    }

    @Action(LanguageTypeActions.GetLanguagesSuccess)
    getLanguagesSuccess(ctx: StateContext<LanguageStateModel>,
      { languages }: LanguageTypeActions.GetLanguagesSuccess
    ) {
      ctx.patchState({
        languages: languages.sort((a, b) => a.languageName.localeCompare(b.languageName))
      });
    }

    @Action(LanguageTypeActions.GetLanguagesFail)
    getLanguagesFailed(
      ctx: StateContext<LanguageStateModel>,
      { error }: LanguageTypeActions.GetLanguagesFail
    ) {
      ctx.patchState({
        error: error,
      });
      MappingUtilsService.showError(this.getTitle(), error, this.alertService, this.localizationService);
    }

    private getTitle() {
      return this.localizationService.translate('labels.language');
    }
  }
